export const GEOSERVER_BASE_URL = "http://geoserver.ncount.in/geoserver";
export const GEOSERVER_WORKSPACE = "nCount";
export const WMS_URL = `${GEOSERVER_BASE_URL}/${GEOSERVER_WORKSPACE}/wms`;

export const getLegendUrl = (layerName) =>
  `${WMS_URL}?service=WMS&request=GetLegendGraphic&format=image/png&layer=${layerName}&transparent=true`;
